import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

export const Grid = styled.div`
  max-width: 1094px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
  .icon-box-item {
    display: flex;
    align-items: center;
    min-width: 0;
    background-color: ${themeGet('colors.white')};
    border: 1px solid ${themeGet('colors.borderColorMuted')};
    border-radius: 18px;
    padding: 14px;
    font-size: 16px;
    font-weight: 700;
    color: ${themeGet('colors.headingColor')};
    box-shadow: ${themeGet('colors.cardShadow')};
  }
`;

export const Figure = styled.figure`
  width: 48px;
  height: 48px;
  margin: 0 14px 0 0;
  border-radius: 14px;
  display: grid;
  place-items: center;
  flex: 0 0 48px;
  background-color: var(--backgroundColor);
  color: ${themeGet('colors.headingColor')};
  font-size: 24px;
`;

export const SectionHeading = styled.div`
  margin-bottom: 48px;
  text-align: center;
  @media (max-width: 600px) {
    margin-bottom: 34px;
  }
  h2 {
    font-weight: 800;
    font-size: 36px;
    line-height: 1.25;
    letter-spacing: -0.03em;
    @media (max-width: 600px) {
      font-size: 28px;
    }
  }
`;
